import { useEffect, useState } from "react";
import Button from "../../../../common/Button";
import ConfirmationModalNew from "../../../../common/ConfirmationModalNew";
import { GeneralTimeTypes } from "./data";

const CustomTimeDialog = ({
  open = false,
  handleClose = () => {},
  confirmAction = (generalTime) => {},
  onCross = () => {},
  time = null,
  buttonRef = null,
}) => {
  const [generalTime, setGeneralTime] = useState([]);
  const [isGeneralTime, setIsGeneralTime] = useState(true);

  const reset = () => {
    setGeneralTime([]);
    setIsGeneralTime(true);
  };

  useEffect(() => {
    if (time && time.length > 0) setGeneralTime(time);
  }, [time]);

  useEffect(() => {
    if (!open || !buttonRef?.current) return;

    const updatePosition = () => {
      if (!buttonRef?.current) return;

      const rect = buttonRef.current.getBoundingClientRect();
      const popupWidth = 445;
      const popupHeight = 400;
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const gap = 8;
      const padding = 16;

      const leftPos = Math.max(
        padding,
        Math.min(rect.left, viewportWidth - popupWidth - padding)
      );

      const topPos = rect.bottom + popupHeight + gap > viewportHeight
        ? Math.max(gap, rect.top - popupHeight - gap)
        : rect.bottom + gap;

      const modalElement = document.querySelector('.custom-time-modal-position');
      if (modalElement) {
        modalElement.style.left = `${leftPos}px`;
        modalElement.style.top = `${topPos}px`;
        modalElement.style.transform = 'none';
      }
    };

    const timeoutId = setTimeout(updatePosition, 0);
    window.addEventListener("scroll", updatePosition, true);
    window.addEventListener("resize", updatePosition);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("scroll", updatePosition, true);
      window.removeEventListener("resize", updatePosition);
    };
  }, [open, buttonRef]);

  return (
    <ConfirmationModalNew
        open={open}
        handleClose={() => {
          onCross();
          reset();
        }}
        onCross={() => {
          handleClose();
          reset();
        }}
        content={() => (
          <div className="flex flex-col gap-8">
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-6">
                <div
                  className={
                    "text-gray-800 border-[1px] justify-center items-center flex h-[48px] border-gray-100 rounded-[4px] p-1"
                  }
                >
                  <Button
                    className={`!border-[0px] !h-[40px] w-full`}
                    type={isGeneralTime ? "primary" : "primary-outline"}
                    text={"General Time"}
                    onClick={() => {
                      setIsGeneralTime(true);
                    }}
                  />
                  <Button
                    className={`!border-[0px] !h-[40px] w-full`}
                    type={!isGeneralTime ? "primary" : "primary-outline"}
                    text={"Specific Time"}
                    toolTipId="custom-time-specific-coming-soon"
                    TooltipComponent={() => (
                      <div className="flex flex-col max-w-md p-2 bg-white text-gray-800 text-sm">
                        Coming Soon
                      </div>
                    )}
                    onClick={() => {
                      setIsGeneralTime(false);
                    }}
                  />
                </div>
                <div className="gap-4 flex flex-col">
                  <p className="flex text-sm text-gray-700">
                    Administration times
                  </p>
                  {isGeneralTime && (
                    <div className="flex flex-row justify-between w-full">
                      {Object.entries(GeneralTimeTypes).map(([key, value]) => (
                        <button
                          key={key}
                          className={`font-semibold text-body-md w-[100px] p-3 h-[36px] justify-center items-center flex rounded-[10px] border-[1px] border-gray-100
              ${
                generalTime.includes(value)
                  ? "text-white bg-REELTeal"
                  : "bg-white text-gray-700"
              }`}
                          onClick={() => {
                            if (generalTime.includes(value))
                              setGeneralTime(
                                generalTime.filter((x) => x !== value)
                              );
                            else setGeneralTime([...generalTime, value]);
                          }}
                        >
                          <p className="font-semibold text-base flex justify-center items-center">
                            {key}
                          </p>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        className="flex flex-col gap-8 max-w-lg w-[445px] bg-gray-20 custom-time-modal-position"
        title="Customize Addministration Times"
        headClassName="p-[24px]"
        confirmText="Save"
        confirmAction={() => {
          confirmAction(generalTime);
          reset();
        }}
      />
  );
};

export default CustomTimeDialog;
